import { render, staticRenderFns } from "./input-uploadfolder.vue?vue&type=template&id=2ce7fd7f&"
import script from "./input-uploadfolder.vue?vue&type=script&lang=js&"
export * from "./input-uploadfolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports